import React from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";

import { Button, Skeleton } from "components";
import { useLoader } from "hooks";
import { uiActions } from "store";

import { ReactComponent as EditIcon } from "static/images/pencil.svg";
import styles from "../userForm.module.scss";

type EditableEmailFieldProps = {
	isLoading?: boolean;
	email: string;
	allowedDomains: string[];
};

const EditableEmailField = ({
	isLoading = false,
	email,
	allowedDomains,
}: EditableEmailFieldProps) => {
	const dispatch = useDispatch();
	const Loader = useLoader(isLoading);

	const openModal = () => {
		dispatch(
			uiActions.showModal("EDIT_EMAIL", {
				currentEmail: email,
				allowedDomains,
			}),
		);
	};

	return (
		<Row>
			<Loader
				skeleton={
					<Col lg={5}>
						<Skeleton variant="text" />
					</Col>
				}
				component={
					<Col lg={5}>
						<Row>
							<Col sm="5">Email</Col>
							<Col sm="7" className="d-flex">
								<div>{email}</div>
								<Button
									onClick={openModal}
									icon={<EditIcon />}
									btnIcon
									variant="secondary"
									size="sm"
									className={styles.editableBtn}
								/>
							</Col>
						</Row>
					</Col>
				}
			/>
		</Row>
	);
};

export default EditableEmailField;
